import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[b2cAccordionHeader]',
})
export class AccordionHeaderDirective {
  templateRef = inject<TemplateRef<unknown>>(TemplateRef);
}
